// @flow

import { curry } from 'lodash';

import fuzzyscore from '@zapier/common-utils/src/fuzzyscore';

import { NAME } from './constants';

const queryScore = curry((query, service) => {
  return -fuzzyscore(query, service[NAME]);
});

export default queryScore;
